// back to top
$(document).ready(function(){
  $('.js-back-to-top').find('.back-to-top_btn').click(function () {
    $('html').animate({ scrollTop: 0 }, 300);
  });
  $(window).on('scroll', commonFunctions.rafThrottle(function (e) {
    var scroll_height_threshold = 400;
    var $back_top = $('.js-back-to-top');
    if ($(window).scrollTop() > scroll_height_threshold) {
      $back_top.css("display", "flex")
    } else {
      $back_top.css("display", "none")
    }
  }));
  $(document).on('click','.toggle-icon-top', function(e){
    $(".footer_menu_top").toggle();
    $(".footer_container_category .toggle-icon-plus").toggleClass("d-none")

  });
  $(document).on('click','.toggle-icon-bottom', function(e){
    $(".footer_menu_bottom").toggle();
    $(".footer_container_skills .toggle-icon-plus").toggleClass("d-none")
  });
})
